import React from "react";
import { FormattedMessage } from "react-intl";
import OutlinedButton from "../OutlinedButton/OutlinedButton";
import { ITextDetailProps, ITextDetailBase } from "./module/constants";
import messages from "./module/messages";

import classes from "./TextDetail.module.scss";

const TextDetail = (props: ITextDetailProps) => {
  const incomingData: ITextDetailBase[] = props.fieldList;

  let outputContent: JSX.Element | JSX.Element[] = [];

  if (incomingData.length <= props.limit) {
    outputContent = incomingData.map((field) => {
      return (
        <div key={`${field.value}+${Math.random()}`} className="row w-100">
          <div className={`col-4 ${classes.label}`}>{field.label}</div>
          <div className="col">{field.value}</div>
          <hr className="w-100" />
        </div>
      );
    });
  } else {
    const maxRowPerColumn = Math.round(incomingData.length / 2);
    const firstColumn = incomingData.slice(0, maxRowPerColumn);
    const secondColumn = incomingData.slice(maxRowPerColumn);

    outputContent = (
      <>
        <div className="row">
          <div className="col">
            {firstColumn.map((field) => {
              return (
                <div
                  key={`${field.value}+${Math.random()}`}
                  className="row w-100"
                >
                  <div className={`col-4 ${classes.label}`}>{field.label}</div>
                  <div className="col">{field.value}</div>
                  <hr />
                </div>
              );
            })}
          </div>
          <div className="col">
            {secondColumn.map((field) => {
              return (
                <div
                  key={`${field.value}+${Math.random()}`}
                  className="row w-100"
                >
                  <div className={`col-4 ${classes.label}`}>{field.label}</div>
                  <div className="col">{field.value}</div>
                  <hr />
                </div>
              );
            })}
          </div>
        </div>
        {props.showInfoBtn && (
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <OutlinedButton onClick={props.onMoreInfoClick}>
              <FormattedMessage {...messages.moreInfo} />
            </OutlinedButton>
          </div>
        )}
      </>
    );
  }

  return <React.Fragment>{outputContent}</React.Fragment>;
};

export default TextDetail;
